/**
 * @module 页面汇总
 * @date 2019-06-06 14:30:49
 * 按需赖加载
 */
import { lazy } from 'react';

// 首页
export const Home = lazy(() => import('./App'));
// 登录页
export const Login = lazy(() => import('./Login'));
export {
  MyTask,
  TaskCreate,
  TaskDetail,
  Descript,
  ProjectCreate,
  ProjectDetail,
  ProjectList,
  ProjectHome,
  Privacy,
  AuthCompany,
  AppLegal,
  AppPrivacy,
  PositionLegal,
  Legal,
  WorkbenchIntro,
  FilePreview,
  UpgradeTips,
  AntPay,
  AntPayResult,
  PersonalVerify,
  AppDownload
} from '@Company/index';
export {
  MResidentLogin,
  MResidentRegister,
  MResidentCreate,
  MResidentHome,
  MResidentSearsh,
  MJobSuggest,
  LachineHome,
  LachineActive,
  LachinePhone,
  LachineQrcode,
  LachineYzm,
  RecommendActive,
  RecommendGuide,
  InviteSuccess,
  MResidentCreateSuccess,
  WakeTest
} from '@MResident/index';
export {
  ResumeList,
  ResumeDetail,
  ResumeSearch,
  WorkExper,
  ProjectExper,
  CandidateList,
  CandidateDetail,
  CandidateSearch,
  HuntJob,
  HuntJobList,
  HuntJobOffer,
  HuntJobSearch,
  PostPosition,
  JobList,
  Business,
  BusinessSearch,
  ZhaopinHome
} from '@Zhaopin/index';
export {
  MonitorAllStats,
  MonitorDashboard,
  MonitorReport,
  MonitorCurdesktop,
  MonitorWarnStat,
  MonitorWarnLog,
  MonitorWarnDetail,
  ScreenShot,
  DingNoRole
} from '@Monitor/index';
export {
  OnlineResume,
  EditBasicMsg,
  JobIntension,
  ResidentWorkExper,
  ResidentProjectExper,
  ResidentEduExper,
  ResidentTrainExper,
  AnnexResume,
  UploadResume,
  RecommendPerson,
  ComputerUpload,
  OtherUpload,
  RecommendReport,
  RecommendUploadResume,
  LogoutProtocol,
  DeliveryDetail,
  Delivery,
  JobDetail,
  CompanyDetail
} from '@Resident/index';

export {
  MEntHome,
  MEntChoose,
  MEntLogin,
  MEntRegister,
  MEntCreate,
  MEntInit,
  MEntFindpwd,
  MEntResetpwd,
  MEntLaxin,
  MEntMarketing,
  MEntMarketingDetail,
  MEntRule,
  MEntAuthCompany,
  MEntCreatCompany,
  NewsSetting,
  PrivateRules,
  ShopLegal,
  HotelMid
} from '@MEnt/index';

export { OKRList, OKRCreate, OKRDetail, OKRSetting, KRDetail, KRCreate } from '@OKR/index';

export { OrderStatus, OrderProtocol, OrderReback } from '@Payment/index';
